<div
  [class.expanded]="isAllItemsVisible"
  class="limited-elements-container"
>
  <div class="limited-elements first-row">
    @for (item of displayedItems; track item) {
      <div class="limited-element">
        <ng-container *ngTemplateOutlet="itemTemplateRef; context: { $implicit: item }"></ng-container>
      </div>
    }
    <button
      #toggleButton
      [hidden]="hiddenItems.length === 0"
      (click)="toggleItemsVisibility()"
      class="toggle theme-color"
    >
      <span
        [@fadeInOut]="isAllItemsVisible ? 'hidden' : 'visible'"
        class="counter theme-background"
      >+{{ hiddenItems.length }}</span>
      <svg
        width="27"
        height="25"
      >
        <mask fill="white">
          <path d="M12.699 4.18628L7.04212 9.84314L12.699 15.5L18.3558 9.84314L12.699 4.18628Z"/>
        </mask>
        <path
          d="M12.699 15.5L13.4061 16.2071L12.699 16.9142L11.9919 16.2071L12.699 15.5ZM7.74922 9.13603L13.4061 14.7929L11.9919 16.2071L6.33501 10.5502L7.74922 9.13603ZM11.9919 14.7929L17.6487 9.13603L19.0629 10.5502L13.4061 16.2071L11.9919 14.7929Z"
          fill="#8AB4F8"
          mask="url(#path-2-inside-1_266_809)"
        />
      </svg>
    </button>
  </div>
  <div
    [@expandCollapse]="isAllItemsVisible ? 'expanded' : 'collapsed'"
    class="limited-elements"
  >
    @for (item of hiddenItems; track item) {
      <div class="limited-element">
        <ng-container *ngTemplateOutlet="itemTemplateRef; context: { $implicit: item }"></ng-container>
      </div>
    }
  </div>
</div>
